/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  Row,
  Col,
} from 'react-bootstrap';
import FontAwesome from '../utils/FontAwesome';
import './BillCard.scss';
import { LimitTheText } from '../utils';

const thermometerSettings = function (thermometer) {
  let perc = '%';
  let color = '';
  let icon = '';

  if (thermometer) {
    if (thermometer >= 70) {
      color = 'success';
      icon = (thermometer >= 80) ? 'full' : 'three-quarters';
    } else if (thermometer < 70 && thermometer >= 30) {
      color = 'warning';
      icon = (thermometer >= 60) ? 'three-quarters' : 'half';
    } else if (thermometer < 30) {
      color = 'danger';
      icon = (thermometer >= 20) ? 'quarter' : 'empty';
    } else if (thermometer === 0) {
      icon = 'empty';
    }
  } else {
    thermometer = 'N/A';
    color = 'muted';
    icon = 'empty';
    perc = '';
  }

  return (
    <>
      { thermometer !== 'N/A' ? (
        <div className={`bill-thermometer text-${color}`} style={{ float: 'left' }}>
          <FontAwesome icon={['fas', `thermometer-${icon}`]} />
          {thermometer}
          {perc}
        </div>
      ) : null }
    </>
  );
};

const Bills = (props) => {
  const bills = props.bills;
  const starred = props.starred;

  return bills.map((bill) => {
    return (
      <Card key={bill.id} style={{ display: 'inline-block' }} className="mr-4 bill col-md-5">
        { starred ? (
          <div className="badge badge-category-starred ph-primary">
            { bill.categories.length === 0 ? 'sem categoria' : bill.categories[0] }
          </div>
        ) : null }
        <Card.Body>
          <Row>
            <Col>
              { bill.configuration && bill.configuration.visibility && bill.configuration.visibility.thermometer ? thermometerSettings(bill.thermometer) : null }
              <div style={{ float: 'left' }}>
                <div className="bill-house-name">{bill.house.name}</div>
                <div className="bill-bill-name">{bill.bill.name}</div>
                <div className="bill-author-name">{bill.author.name}</div>
              </div>
            </Col>
          </Row>
          <div className="bill-card-content">
            <Row style={{ whiteSpace: 'initial' }}>
              <Col className="my-4">
                { LimitTheText(bill.bill.description.replace(/<\/?[^>]+(>|$)/g, ''), 300) }
              </Col>
            </Row>
            <Row style={{ whiteSpace: 'initial' }}>
              <Col className="my-2">
                <strong>{ bill.bill.last_step.date }</strong>
                { ` - ${bill.bill.last_step.committee}: ` }
                { LimitTheText(bill.bill.last_step.content.replace(/<\/?[^>]+(>|$)/g, ''), 200) }
              </Col>
            </Row>
          </div>
          <div style={{ bottom: '20px', position: 'absolute', right: '20px' }}>
            <a href={`/projeto/${bill.id}`} className="btn btn-ph-secondary">Abrir na íntegra</a>
          </div>
        </Card.Body>
      </Card>
    );
  });
}

class BillCard extends Component {
  render() {
    const { bills, starred, category } = this.props;
    const categoryName = category === '' ? 'sem categoria' : category;

    return (
      <Row className="bills scrollbar-container m-4">
        { !starred ? (
          <>
            <a id={`categoria-${categoryName}`} />
            <div className="badge badge-category-all ph-primary">
              { categoryName }
            </div>
          </>
        ) : null }

        <Bills bills={bills} starred={starred} />

      </Row>
    );
  }
}

BillCard.propTypes = {
  bills: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
    }),
  ),
  starred: PropTypes.bool,
  category: PropTypes.string,
};

BillCard.defaultProps = {
  bills: {
    id: PropTypes.number,
  },
  starred: false,
  category: '',
};

export default BillCard;
